class Country {
  constructor(data) {
    this.backgroundImage = String(data.backgroundImage); // Url to the background-image.
    this.parts = new Map(data.parts); // Array of Country parts.
  }
}

export default Country;
